import { withInstall } from '@lit-element/utils'

import ColorPicker from './src/color-picker.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtColorPicker: SFCWithInstall<typeof ColorPicker> =
  withInstall(ColorPicker)
export default LtColorPicker

export * from './src/color-picker'
